import React, { useState, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  IconButton,
  Drawer,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import { TiThMenu } from "react-icons/ti";
import Userlist from "../List/userlist";
import Configlist from "../List/configlist";
import useReactRouter from "use-react-router";
import { LangContext } from "../../Context/Langcontext";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("xs")]: {
      display: "block",
    },
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
    [theme.breakpoints.down("md")]: {
      display: "block",
    },
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    display: "flex",
    alignItems: "center",
  },
  toolbar: theme.mixins.toolbar,
  listitem: {
    borderRadius: 25,
    margin: "0.2rem",
  },
  image: { width: "auto", height: "3.5rem", marginTop: "1rem" },
}));

const MenuMobile = () => {
  const classes = useStyles();
  const [open, setopen] = useState(false);
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { location, history } = useReactRouter();

  let list = [
    { name: lang.HOME, path: "/home/main" },
    { name: lang.SERVICE, path: "/home/service" },
    { name: lang.PRICING, path: "/home/pricing" },
    { name: lang.DOCUMENT, path: "/home/document" },
    { name: lang.SUPPORT, path: "/home/support" },
  ];

  const [role] = useState(
    localStorage.getItem("role") === "admin"
      ? "Administrator"
      : localStorage.getItem("role") === "root"
      ? "Administrator"
      : "Contract User"
  );
  const [choice, setChoice] = useState(role === "Administrator" ? 0 : null);

  const pageList = () => {
    return (
      <div style={{ width: "90%" }}>
        <div className={classes.toolbar}>
          <img
            alt="logo"
            src={require("../../images/LOGO/logo2.png")}
            className={classes.image}
            onClick={() => {
              history.push("/home");
              window.scrollTo(0, 0);
            }}
          />
        </div>
        <Divider />
        <List>
          {list.map((rs) => {
            return (
              <ListItem
                key={rs.name}
                selected={location.pathname === rs.path}
                button
                className={classes.listitem}
                onClick={() => {
                  history.push(rs.path);
                  window.scrollTo(0, 0);
                  setopen(!open);
                }}
              >
                <ListItemText
                  primary={rs.name}
                  disableTypography
                  style={{
                    color: location.pathname === rs.path ? "#E16733" : "",
                  }}
                />
              </ListItem>
            );
          })}
        </List>
      </div>
    );
  };
  return (
    <div className={classes.root}>
      <IconButton
        onClick={() => {
          setopen(true);
        }}
      >
        <TiThMenu color="#E16733" />
      </IconButton>
      <Drawer
        className={classes.drawer}
        anchor="left"
        open={open}
        onClose={() => {
          setopen(false);
        }}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        {location.pathname.startsWith("/home") ? (
          pageList()
        ) : !location.pathname.startsWith("/app/user/") ? (
          <Userlist
            choice={choice}
            setChoice={setChoice}
            role={role}
            setopen={setopen}
          />
        ) : (
          <Configlist
            choice={choice}
            setChoice={setChoice}
            role={role}
            setopen={setopen}
          />
        )}
      </Drawer>
    </div>
  );
};

export default MenuMobile;
